<template>
  <div>
    <v-layout
      row
      justify-center>
      <v-dialog
        v-model="formDialog.show"
        persistent
        scrollable
        max-width="1000px" >
        <v-card>
          <v-card-title>
            {{ formDialog.title }}
            <v-progress-linear
              v-if="formDialog.saving"
              v-model="formDialog.saving"
              :indeterminate="formDialog.saving"/>
          </v-card-title>
          <v-divider/>
          <v-card-text style="height: 500px;">
            <v-alert
              :value="formDialog.saved"
              :type="formDialog.alertType"
            >
              {{ formDialog.alertMessage }}
            </v-alert>
            <v-container>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                  v-model="formDialog.fields.Acct_name"
                  label="Account Name"/>
                <v-select
                  :items="['New','Pending','N/A']"
                  v-model="formDialog.fields.Acct_status"
                  attach
                  label="Standard"
                />
                <v-text-field
                  v-model="formDialog.fields.Acct_DL"
                  label="Account DL"/>

                <v-menu
                  v-model="date_onboarded"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="formDialog.fields.Date_onboarded"
                      label="Date Onboarded"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="formDialog.fields.Date_onboarded"
                    @input="date_onboarded = false"/>
                </v-menu>
                <v-menu
                  v-model="show_calendar"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="formDialog.fields.Last_Date_Validated"
                      label="Last Date Validated"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="formDialog.fields.Last_Date_Validated"
                    @input="show_calendar = false"/>
                </v-menu>
                <v-text-field
                  v-model="formDialog.fields.Date_Suspended"
                  label="Date Suspended"/>
                <!-- <v-text-field
                  v-model="formDialog.fields.Date_onboarded"
                  label="Date Onboarded"/> -->
                <!-- <v-text-field
                  v-model="formDialog.fields.Last_Date_Validated"
                  label="Date Validated"/> -->
                <v-text-field
                  v-model="formDialog.fields.Date_Requested_change"
                  label="Date Requested Change"/>
                <v-text-field
                  v-model="formDialog.fields.MP_ID"
                  label="MP ID"/>
                <v-text-field
                  v-model="formDialog.fields.Managed_Svc"
                  label="Managed SVC"/>
                <!-- <v-text-field
                  v-model="formDialog.fields.Acct_status"
                  label="Account Status"/> -->
                <v-text-field
                  v-model="formDialog.fields.AWS_Support_Type"
                  label="AWS Support Type"/>
                <v-switch
                  v-model="formDialog.fields.Is_MP"
                  :label="`Is this a Master Payer?`"
                  value="Yes"/>
                <v-text-field
                  v-model="formDialog.fields.Acct_Description"
                  label="Account Description"/>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              :loading="formDialog.saving"
              color="primary"
              flat
              @click="onSave">{{ formDialog.saveLabel }}</v-btn>
            <v-btn
              color="primary"
              flat
              @click.stop="onCancel">{{ formDialog.cancelLabel }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      valid: true,
      switch1: true,
      show_calendar: false
      // requiredRules: [
      //   v => !!v || 'Field is required',
      //   // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      // ],
      // emailRules: [
      //   v => !!v || 'E-mail is required',
      //   v => /.+@.+/.test(v) || 'E-mail must be valid'
      // ]
    }
  },
  computed: mapState(['formDialog']),
  // ...mapState('formDialog'),
  // isSaving() {
  //   return this.$store.getters.getFormDialogSaving
  // },
  // isSave() {
  //   return this.$store.getters.getFormDialogSuccess
  // }
  // },
  methods: {
    onSave () {
      console.log('on save')
      this.formDialog.saveHandler(this.formDialog.fields)
    },
    onCancel () {
      this.$store.commit('resetFormDialog', { root: true })
    }
  }
}
</script>
<style lang="scss" scoped>
  .v-progress-linear {
      margin: 0;
      bottom: -15px;
  }
</style>
